export default {
  USER_ID: "user_yDX8KEV5rhz0F7sXOgnre",
  TEMPLATE_ID: "template_0kvl16m",
};
